module.exports = __webpack_public_path__ + "static/media/28DGC4.c12fd47d.jpg";